import { SearchLogeye } from 'common/types/entities/api/logeye'
import { StateKey } from 'common/utils/flipState'
import { excludeLogeyeTrCode, TRCode } from 'common/services/naverAnalytics'
import { axios, getHeadersWithClientIp } from 'common/utils/ajax/axios'

export const initialLogeye: SearchLogeye = {
  reqId: null,
  status: null,
  message: null,
  tracks: null,
}

const FETCH = 'logeye/FETCH'

export const fetchLogeye = (
  curState: StateKey,
  storeId: string,
  trackChannel?: string,
  isCollectedLogeye?: boolean,
  headers?: any,
) => async dispatch => {
  if (isCollectedLogeye) {
    if (
      !trackChannel ||
      trackChannel === TRCode.SWN ||
      trackChannel.length === 0 ||
      excludeLogeyeTrCode(trackChannel)
    ) {
      return
    }

    await axios.put(
      `/v1/logeye`,
      {
        trackChannel,
        storeId,
      },
      {
        ...getHeadersWithClientIp(headers),
      },
    )
  }

  const response = await axios.get<SearchLogeye>(`/v1/logeye/search?storeId=${storeId}`, {
    ...getHeadersWithClientIp(headers),
  })

  const logeye: SearchLogeye = (response && response.data) || initialLogeye
  dispatch({
    curState,
    logeye,
    type: FETCH,
  })
}

const logeyeReducer = (state = initialLogeye, action) => {
  switch (action.type) {
    case FETCH:
      return action.logeye
    default:
      return state
  }
}

export default logeyeReducer
